import { render, staticRenderFns } from "./ScrollSpy.vue?vue&type=template&id=2dda5391&"
import script from "./ScrollSpy.vue?vue&type=script&lang=js&"
export * from "./ScrollSpy.vue?vue&type=script&lang=js&"
import style0 from "./ScrollSpy.vue?vue&type=style&index=0&id=2dda5391&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports